// extracted by mini-css-extract-plugin
module.exports = {"imgbox":"albumimg-module--imgbox--mjtRd","imgthumb":"albumimg-module--imgthumb--mg59r"};